import HomepageImg from '../../../../assets/App_Img/Itinerary_Img.jpeg';
import RestaurantImg from '../../../../assets/App_Img/RestaurantImg.jpeg';
import AgentDashboardImg from '../../../../assets/Agent_Portal_Dashboard.jpeg';
import VoucherMockupImg from '../../../../assets/App_Img/VoucherCreationMockup.png';
import BgImage from '../../../../assets/why_trrip_bg_1769531997717.png';
import SmartVouchersHeader from './sections/SmartVouchersHeader';
import LaptopMockup from './sections/LaptopMockup';
import GlassCardMockup from './sections/GlassCardMockup';
import PhoneMockup from './sections/PhoneMockup';

const DashboardPlaceholder =
  'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80';
const VoucherPlaceholder =
  'https://images.unsplash.com/photo-1611162617474-5b21e879e113?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80';

const SmartVouchersSection = () => {
  return (
    <section className="py-24 px-4 md:px-8 lg:px-12 relative overflow-hidden bg-[#067978]">
      {/* Background Image with Primary Color Filter */}
      <div className="absolute inset-0 z-0 bg-[#067978]">
        <img
          src={BgImage}
          alt="Global Network"
          className="w-full h-full object-cover opacity-20 mix-blend-luminosity"
        />
        <div className="absolute inset-0 bg-[#067978]/60 backdrop-blur-[2px]" />
      </div>

      <div className="relative z-10 max-w-[1500px] mx-auto w-full space-y-16">
        {/* Header */}
        <SmartVouchersHeader />

        {/* Custom Responsive Flex / Grid Layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:flex lg:flex-row justify-center items-center lg:items-end gap-10 sm:gap-8 lg:gap-6 xl:gap-10 w-full pt-6 sm:pt-8">
          {/* Item 1: Agent Dashboard (Laptop) */}
          <div className="flex flex-col items-center w-full sm:col-span-2 lg:col-span-1 lg:w-[420px] xl:w-[480px] group">
            <div className="w-full max-w-[280px] sm:max-w-[380px] md:max-w-[420px] lg:max-w-full mx-auto">
              <LaptopMockup src={AgentDashboardImg || DashboardPlaceholder} />
            </div>
            <div className="mt-5 sm:mt-6 text-center">
              <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-white/10 text-white flex items-center justify-center font-medium text-xs mx-auto mb-2 sm:mb-3">
                1
              </div>
              <h3 className="text-white font-semibold text-sm sm:text-base transition-colors drop-shadow-sm">
                Your portal
              </h3>
              <p className="text-white/70 text-xs sm:text-[13px] mt-1 max-w-[200px] mx-auto leading-relaxed">
                Manage every trip from one dashboard
              </p>
            </div>
          </div>

          {/* Item 2: Voucher Creation (Glass Card) */}
          <div className="flex flex-col items-center w-full lg:w-[220px] xl:w-[250px] group">
            <div className="w-full max-w-[180px] sm:max-w-[220px] lg:max-w-full mx-auto">
              <GlassCardMockup src={VoucherMockupImg || VoucherPlaceholder} />
            </div>
            <div className="mt-5 sm:mt-6 text-center">
              <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-white/10 text-white flex items-center justify-center font-medium text-xs mx-auto mb-2 sm:mb-3">
                2
              </div>
              <h3 className="text-white font-semibold text-sm sm:text-base transition-colors drop-shadow-sm">
                Add to a booking
              </h3>
              <p className="text-white/70 text-xs sm:text-[13px] mt-1 max-w-[200px] mx-auto leading-relaxed">
                Pull bookings together. Send the branded app.
              </p>
            </div>
          </div>

          {/* Item 3: Traveller Itinerary View (Phone) */}
          <div className="flex flex-col items-center w-full lg:w-[190px] xl:w-[210px] group">
            <div className="w-full max-w-[160px] sm:max-w-[190px] lg:max-w-full mx-auto">
              <PhoneMockup src={HomepageImg} />
            </div>
            <div className="mt-5 sm:mt-6 text-center">
              <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-white/10 text-white flex items-center justify-center font-medium text-xs mx-auto mb-2 sm:mb-3">
                3
              </div>
              <h3 className="text-white font-semibold text-sm sm:text-base transition-colors drop-shadow-sm">
                Their trip view
              </h3>
              <p className="text-white/70 text-xs sm:text-[13px] mt-1 max-w-[200px] mx-auto leading-relaxed">
                Weather, schedule, packing — all in one place
              </p>
            </div>
          </div>

          {/* Item 4: Restaurants & Shops (Phone) */}
          <div className="flex flex-col items-center w-full lg:w-[190px] xl:w-[210px] group">
            <div className="w-full max-w-[160px] sm:max-w-[190px] lg:max-w-full mx-auto">
              <PhoneMockup src={RestaurantImg} />
            </div>
            <div className="mt-5 sm:mt-6 text-center">
              <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-white/10 text-white flex items-center justify-center font-medium text-xs mx-auto mb-2 sm:mb-3">
                4
              </div>
              <h3 className="text-white font-semibold text-sm sm:text-base transition-colors drop-shadow-sm">
                Curated picks
              </h3>
              <p className="text-white/70 text-xs sm:text-[13px] mt-1 max-w-[200px] mx-auto leading-relaxed">
                Dining, shopping, activities — handpicked
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SmartVouchersSection;
